var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// var length = $(".product-slideshow .product-media").length;
//   console.log(length);
//   if(length > 1){
//     $(".product-slideshow .product-media:first-child").addClass("hide");
//   }
// Announcement Bar

$().ready(function(){
  $('.slick-carousel.announcement-bar__text').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: false,
    infinite: true
  });
});

// Header
setTimeout(function() {
    $("body").addClass("abz-transition");
}, 2000);

// Header Logo


$('.header-logo-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  speed: 3000,
  infinite: true,
  fade: true,
  autoplay: true,
  cssEase: 'linear'
});


// Subscription Page

$('.abz-opne-click').click(function(){
    $(this).parents().siblings().find(".abz-list-of-question").removeClass("active");
    $(this).closest(".abz-list-of-question").toggleClass("active");
})

// Our Store Page


// $('.abz-gallery .image-overlay .abz-our-store-location').click(function(){
//     $(this).parents().siblings().find(".inner").removeClass("active");
//     $(this).closest(".gallery__item").find(".inner").toggleClass("active");
// })


// Mobile Search
/*
if (screen.width <= 767) {
 $(".hidden-search-container").click(function(){
    $('.main-search').show();
});
}*/

// Collection Page

jQuery(function($) {
  var path = window.location.href; 
  // because the 'href' property of the DOM element is the absolute path
  $('.collection-page-list a').each(function() {
    if (this.href === path) {
      $(this).addClass('active');
    }
  });
});

